import { render, staticRenderFns } from "./RIDetails.vue?vue&type=template&id=13e652bd&"
import script from "./RIDetails.vue?vue&type=script&lang=js&"
export * from "./RIDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports